export const environment = {
  production: true,
  deployment: "prod",
  internal: false,
  oidc: {
    redirectUri: `${window.location.origin}/login/callback`,
    clientId: "WAH_47cd1494-a6d1-4dd6-9ee0-61526e2212bb",
    issuer: "https://vanguard.okta.com/oauth2/austuiwbokf0be0WP357",
    scopes: ["openid", "profile", "email"],
    testing: {
      disableHttpsCheck: false,
    },
  },
  proxyServer: "https://personal1.vanguard.com/wah-wah-proxy/",
  LOGON_URL:
    "https://logon.vanguard.com/logon?TARGET_OVERRIDE=https://wealth-planning.web.vanguard.com/personal-wealth-inventory",
  jwtExchangeUrl: "https://oauthi.opsp.c1.vanguard.com/auth/oauth/v1/jwtexchange",
  appUrl: "https://wealth-planning.web.vanguard.com",
  vgnUrl: "https://n4v.web.vanguard.com/secure-site-components.js",
  gatekeeeper_url: "https://gatekeeper-rs-webservice.essp.c1.vanguard.com/gat/toggles/VEX",
  gatekeeper_env: "PROD",
  c3Url: "https://mc3-static-assets.web.vanguard.com/vg-ccc-serverless/latest/vg-ccc-serverless.js",
  logger_environment: "production",
  consultationPrepUrl: "https://estate-planning-external.web.vanguard.com/consultation-prep",
  landingPageUrl: "https://estate-planning-external.web.vanguard.com",
  toolsPageUrl: "https://personal-advisor.vanguard.com/manage/tools/",
};
